// extracted by mini-css-extract-plugin
var _1 = "CommentHistoryView-module__animateUploadProgressBarWidth--mmRtu";
var _2 = "CommentHistoryView-module__animatedBackground--Zy34b";
var _3 = "CommentHistoryView-module__content--CCca9";
var _4 = "CommentHistoryView-module__editor--K4uLR";
var _5 = "CommentHistoryView-module__editorWrapper--Q5Sj0";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "content", _4 as "editor", _5 as "editorWrapper" }
